// ! ATTENTION ! NE PAS TOUCHER ! Le contenu de ce fichier est modifié lors de la build

export const APP_VERSION = '2.1.13.16 (85711)';
